"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Essentials_module_1 = require("./modules/Essentials.module");
const loadEssentialsModule = () => ({
    hasRouter: false,
    modules: [(0, Essentials_module_1.default)()],
});
exports.default = loadEssentialsModule;
